import { adminHttpClient } from '../commons/adminHttpClient'
import { ExpenseTypeEligibility } from '../../domain/expenses/expenseTypeEligibility'
import { RecurringExpenseFrequency } from '../../domain/expenses/ReccuringExpenseFrequency'
import { RecurringExpenseStatus } from '../../domain/expenses/RecurringExpenseStatus'

export interface PremiumForSaveResponse {
  recurringExpenseId?: string
  name: string
  familyMemberId?: string
  requestedAmount: number
  startDate: string
  messageToEmployee?: string
  frequency: RecurringExpenseFrequency
  description?: string
  minPurchasedDate: string
  maxPurchasedDate: string
  expenseType: ForSaveExpenseType
  attachments: Attachment[]
  familyMemberCoveredByThisPolicyIds: string[]
  expenseStatus: RecurringExpenseStatus
  requiresAttestationConfirmationToSubmitExpense: boolean
  coveredByAnIndividualHealthInsurancePolicy: boolean
}

type Attachment = {
  attachmentId: string
  fileNameUrl: string
  title: string
  reuseInOtherExpenses: boolean
}

type ForSaveExpenseType = {
  id: string
  name: string
  eligibility: ExpenseTypeEligibility
}

export const getPremiumForSave = (
  planPeriodId: string,
  expenseTypeId: number,
  recurringExpenseId?: string,
): Promise<PremiumForSaveResponse> => {
  return adminHttpClient.get(`/Expenses/PremiumForSave/${planPeriodId}/${expenseTypeId}/${recurringExpenseId ?? ''}`)
}
